import { Flex, Grid } from '@chakra-ui/react';

import { ViewStar } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const CompensationOverview = () => (
  <Flex flexDir="column" bg="white" p="12px" borderRadius="8px" gap="12px">
    <Flex pb="8px" borderBottom="1px solid" borderColor="#E7E7E7">
      <TextBodyMedium bold>Overview</TextBodyMedium>
    </Flex>
    <Grid templateColumns="repeat(2, 1fr)" columnGap="40px" rowGap="8px" w="100%">
      <Flex flexDir="column" gap="4px">
        <TextLabel color="text.g2">Performance rating</TextLabel>
        <TextBodyMedium py="10px" display="flex" alignItems="center" gap="4px">
          <Flex h="20px" w="20px" align="center" justify="center" bg="#E1F7E2" borderRadius="50%">
            <ViewStar boxSize="12px" color="functional.1A5724" />
          </Flex>
          Exceeds expectations
        </TextBodyMedium>
      </Flex>
      <Flex flexDir="column" gap="4px">
        <TextLabel color="text.g2">Churn likelihood</TextLabel>
        <TextBodyMedium py="10px">High</TextBodyMedium>
      </Flex>
      <Flex flexDir="column" gap="4px">
        <TextLabel color="text.g2">Compa ratio</TextLabel>
        <TextBodyMedium py="10px">78%</TextBodyMedium>
      </Flex>
      <Flex flexDir="column" gap="4px">
        <TextLabel color="text.g2">Last date of comp change</TextLabel>
        <TextBodyMedium py="10px">June 8, 2024</TextBodyMedium>
      </Flex>
    </Grid>
  </Flex>
);
